import React, { useEffect } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { TeamsData } from "../../assets/media";
import "./TeamMemberDetail.css";

const TeamMemberDetail = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const category = searchParams.get("category");
  const index = parseInt(searchParams.get("index"), 10);

  const teamList = category ? TeamsData[category] : null;
  const member =
    teamList && Number.isInteger(index) && index >= 0 && index < teamList.length
      ? teamList[index]
      : null;

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  if (!member) {
    return (
      <div className="team-member-detail team-member-detail--error">
        <p>Member not found.</p>
        <button type="button" onClick={() => navigate("/teams")}>
          Back to Teams
        </button>
      </div>
    );
  }

  return (
    <div className="team-member-detail">
      <div className="team-member-detail__inner">
        <div className="team-member-detail__media">
          <img
            src={member.image}
            alt={member.name}
            className="team-member-detail__image"
          />
        </div>
        <div className="team-member-detail__content">
          <h1 className="team-member-detail__name">{member.name}</h1>
          <p className="team-member-detail__description">{member.description}</p>
        </div>
      </div>
      <button
        type="button"
        className="team-member-detail__back"
        onClick={() => navigate("/teams")}
      >
        Back to Teams
      </button>
    </div>
  );
};

export default TeamMemberDetail;
